var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M8 0C3.587 0 0 3.587 0 8s3.587 8 8 8 8-3.587 8-8-3.587-8-8-8zm4.648 6.35l-5.136 5.136c-.118.118-.27.186-.42.186-.153 0-.305-.068-.423-.186l-2.83-2.83c-.236-.235-.236-.622 0-.858s.623-.236.86 0l2.39 2.39 4.716-4.714c.236-.236.623-.236.86 0 .218.252.218.64-.018.875z"}));
}

CheckCircle.defaultProps = {"fill":"#5e9929","width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
